/** Register service worker so cold offline refresh serves the app shell (not Chrome dino). */
export function registerServiceWorker() {
    if (!("serviceWorker" in navigator)) {
        return;
    }

    const swUrl = `${process.env.PUBLIC_URL || ""}/service-worker.js`;

    window.addEventListener("load", () => {
        navigator.serviceWorker
            .register(swUrl)
            .then(async (registration) => {
                console.info(
                    "[SW] registered",
                    registration.scope,
                    `(${process.env.NODE_ENV})`,
                );

                if (registration.waiting) {
                    registration.waiting.postMessage({ type: "SKIP_WAITING" });
                }

                await navigator.serviceWorker.ready;

                // Warm critical CRA / shell assets into the SW cache while online
                warmShellCache(registration);

                registration.onupdatefound = () => {
                    const installing = registration.installing;
                    if (!installing) return;
                    installing.onstatechange = () => {
                        if (installing.state === "installed") {
                            if (navigator.serviceWorker.controller) {
                                console.info(
                                    "[SW] New version available — refresh when convenient.",
                                );
                            } else {
                                console.info(
                                    "[SW] Content cached for offline use.",
                                );
                            }
                        }
                    };
                };
            })
            .catch((error) => {
                console.warn("[SW] registration failed:", error);
            });
    });
}

function warmShellCache(registration: ServiceWorkerRegistration) {
    if (typeof navigator !== "undefined" && !navigator.onLine) return;

    const urls = new Set<string>([
        "/",
        "/index.html",
        "/manifest.json",
        "/favicon.ico",
        "/logo192.png",
        "/logo512.png",
        "/static/js/bundle.js",
        window.location.pathname,
        window.location.href,
    ]);

    // Cache every script/link the current document already loaded
    document.querySelectorAll("script[src]").forEach((el) => {
        const src = (el as HTMLScriptElement).src;
        if (src) urls.add(src);
    });
    document.querySelectorAll('link[rel="stylesheet"]').forEach((el) => {
        const href = (el as HTMLLinkElement).href;
        if (href) urls.add(href);
    });

    const list = Array.from(urls);
    const worker = registration.active || navigator.serviceWorker.controller;
    if (worker) {
        worker.postMessage({ type: "WARM_CACHE", urls: list });
    }

    // Also fetch from the page so the SW fetch handler can cache responses
    list.forEach((url) => {
        fetch(url, { credentials: "same-origin" }).catch(() => undefined);
    });

    console.info("[SW] warming cache for", list.length, "urls");
}
